import { getCustomDataLabelsOptions } from './reusableGraphOptions'
import { formatReportNumber } from '../../../../features/formatters'

export const getOptions = ({
  legendContainerId,
  datasets,
  currencySymbol,
  showYAxisLabels = false,
  hideLegend = false
}) => {
  const maxValueInDataSets = Math.max(...datasets.map(data => Math.max(...data.data)))

  return {
    scales: {
      x: {
        ticks: {
          display: true,
          color: '#000',
          font: {
            size: 17,
            weight: 400
          }
        },
        grid: {
          display: false
        },
        border: {
          dash: [6, 6],
          display: true,
          color: '#000'
        }
      },
      y: {
        ticks: {
          display: showYAxisLabels,
          ...(showYAxisLabels && {
            color: '#000',
            font: {
              size: 12,
              weight: 400
            },
            callback: function (value) {
              return Math.round(value).toLocaleString()
            }
          })
        },
        grid: {
          drawBorder: false,
          drawOnChartArea: true,
          dash: [6, 6]
        },
        border: {
          display: false,
          dash: [6, 6]
        }
      }
    },

    // legend:
    plugins: {
      legend: { display: false },
      ...(hideLegend
        ? {}
        : {
            htmlLegend: {
              // ID of the container to put the legend in
              containerID: legendContainerId
            }
          }),
      datalabels: getCustomDataLabelsOptions({ maxValue: maxValueInDataSets, fontSize: 9, currencySymbol }),
      tooltip: {
        callbacks: {
          label: tooltipItem =>
            formatReportNumber({ value: tooltipItem.raw, format: 'currency', currency: currencySymbol })
        }
      }
    }
  }
}
